/**
 * Admin MFA API wrappers — used from the user management screen.
 *
 * Both endpoints are admin-gated server-side and authenticate via the
 * HTTP-only session cookie (no X-MFA-Token here — that is login-flow only).
 */
import { apiCall } from './apiUtils';

export const adminListUserFactors = async (userId) =>
  apiCall(`/api/admin/users/${encodeURIComponent(userId)}/mfa-factors`, { method: 'GET' });

export const adminResetUserMfa = async (userId) =>
  apiCall(`/api/admin/users/${encodeURIComponent(userId)}/mfa-factors`, { method: 'DELETE' });
